<template>
    <div>
        <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">{{$t($store.state.authInfo.authModal.title)}}</p>
        </header>
        
        <section class="modal-card-body">
                <b-field :label="$t('message.emailAddress')">
                    <b-input custom-class="binput" type="email" v-model.trim="email">
                    </b-input>
                </b-field>

            <b-field :label="$t('message.password')">
                <b-input custom-class="binput" type="password" v-model.trim="password">
                </b-input>
            </b-field>

            <div style="height: 20px;">
                    &nbsp;
            </div>
            <div style="width: 100%; text-align: center;">
                <a @click="login()" class="button is-medium is-primary">{{$t('message.login')}}</a>
            </div>
            
        </section>

        </div>
    </div>
    
</template>

<script>
    export default {
        props: ['modalTitle'],
        data() {
            return {
                email: this.$store.state.authInfo.authModal.admin == 1 ? this.$store.state.authInfo.userEmail : '',
                password: ''
            }
        },
        methods: {
            login() {
                this.$store.dispatch('approveAction', 
                    {
                        email: this.email, 
                        password: this.password,
                        carryForwardParams: this.$store.state.authInfo.authModal
                    }
                )
            }
        }
    }
</script>

<style scoped>

    .container {
        width: 30%;
        padding: 20px;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        background-color: #fff; 
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        height: 400px;
    }


/* Change styles for span and cancel button on extra small screens */
@media screen and (max-width: 1024px) {
    .container {
      width: 80%;
    }
    img {
      width: 70%;
    }
}

@media screen and (max-width: 300px) {
    
}

</style>



// WEBPACK FOOTER //
// src/views/Sessions/PermissionAuth/Index.vue